var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"c-input-small",class:_vm.customClass,attrs:{"value":_vm.value,"items":_vm.filteredOptions,"label":_vm.label,"disabled":_vm.disabled,"outlined":_vm.outlined,"dense":_vm.dense,"hide-details":_vm.hideDetails,"single-line":_vm.singleLine,"clearable":_vm.clearable},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }